<template>
  <header class="header">
    <tracker-create-modal />
    <div>
      <app-search-bar @submit="filter"></app-search-bar>
    </div>
  </header>
</template>
   
<script>
import TrackerCreateModal from "@components/modules/tracker/create/modal/TrackerCreateModal.vue";
import AppSearchBar from "@components/Search";
import EventBus from "../../../packages/event-bus";

export default {
  components: {
    TrackerCreateModal,
    AppSearchBar
  },

  computed: {},

  methods: {
    filter(value) {
      this.$store.commit("TRACKERS_SET_FILTER", {
        key: "search",
        value,
      });
      EventBus.$emit("RELOAD_TRACKER_LIST")
    }
  }
};
</script>
  
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
  